import axios from "axios";
import constant from "./constant";

const token = JSON.parse(localStorage.getItem("authUser"))?.token;
const id = JSON.parse(localStorage.getItem("authUser"))?.response?._id;
const creatorId = JSON.parse(localStorage.getItem("authUser"))?.response?._id;
const firmId =
  JSON.parse(localStorage.getItem("authUser"))?.response?.adminId ||
  JSON.parse(localStorage.getItem("authUser"))?.response?.firmId;
const Role = JSON.parse(localStorage.getItem("authUser"))?.response?.role;

const createAxiosInstance = axios.create({
  baseURL: `${constant.appBaseUrl}/api/`,
  headers: {
    "Content-Type": "multipart/form-data",
    Authorization: token ? `Bearer ${token}` : null,
  },
});

const axiosInstance = axios.create({
  baseURL: `${constant.appBaseUrl}/api/`,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = JSON.parse(localStorage.getItem("authUser"))?.token;
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  response=>response,
  error=>{
    if(error.response?.status===401){
      localStorage.removeItem("authUser");
      localStorage.removeItem("isLocked");
      if(window.location.pathname!=="/login"){
        window.location.replace("/login");
      }
      return Promise.reject(error);
    }
    return Promise.reject(
      error.response?.data || error
    );
  }
);

// 🔥 CREATE
export const createDepartmentApi = async (data) => {
  try {
    const res = await axiosInstance.post("/department/create", data);
    return res.data;
  } catch (error) {
    throw error;
  }
};

// 🔥 GET ALL
export const getDepartmentsApi = async (params = {}) => {
  try {
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, v]) => v !== "" && v !== undefined)
    );

    const res = await axiosInstance.get("/department/getAll", {
      params: filteredParams,
    });

    return res.data;
  } catch (error) {
    throw error;
  }
};

// 🔥 GET BY ID
export const getDepartmentByIdApi = async (id) => {
  try {
    const res = await axiosInstance.get(`/department/${id}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

// 🔥 UPDATE
export const updateDepartmentApi = async (id, data) => {
  try {
    const res = await axiosInstance.put(`/department/${id}`, data);
    return res.data;
  } catch (error) {
    throw error;
  }
};

// 🔥 DELETE
export const deleteDepartmentApi = async (id) => {
  try {
    const res = await axiosInstance.delete(`/department/${id}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

// 🔥 REACTIVATE
export const reactivateDepartmentApi = async (id) => {
  try {
    const res = await axiosInstance.put(`/department/reactivate/${id}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

// 🔥 SUB DEPARTMENTS
export const getSubDepartmentsApi = async (parentId) => {
  try {
    const res = await axiosInstance.get(`/department/by-parent/${parentId}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};
// 🔥 Inactive DEPARTMENTS
export const getInactiveDepartmentsApi = async (params = {}) => {
  try {
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, v]) => v !== "" && v !== undefined)
    );

    const res = await axiosInstance.get(`/department/inactive`, {
      params: filteredParams
    });

    return res.data;
  } catch (error) {
    throw error;
  }
};

// 🔥 WITH DESIGNATIONS
export const getDeptWithDesignationApi = async (id) => {
  try {
    const res = await axiosInstance.get(`/department/with-designations/${id}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};
export default axiosInstance;